/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { DatePicker, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import { getPopupContainerBody } from '../ShippingManagement/shipmentFieldOptions';
import '../../pages/dpr/DPRPage.css';

const PIPELINE_SELECT_DROPDOWN = 'modern-dropdown-popup mc-dpr-modal-select-dd heat-profile-select-dropdown';
const PIPELINE_SELECT_CLASS = 'spacer-log-filter-select';

const SpacerLogDayToolbar = ({
  logDate,
  onLogDateChange,
  pipelines = [],
  sowId,
  onSowChange,
  dataRange,
  shiftFilter,
  onShiftFilterChange,
  showShiftToggle = true,
  showAiInsights = false,
  onOpenAiInsight,
  aiDisabledReason = null,
}) => {
  const pickerValue = logDate ? moment(logDate, 'YYYY-MM-DD') : null;

  const disabledDate = (current) => {
    if (!current) return false;
    if (dataRange?.firstLogDate && current.isBefore(dataRange.firstLogDate, 'day')) return true;
    if (dataRange?.lastLogDate && current.isAfter(dataRange.lastLogDate, 'day')) return true;
    return false;
  };

  const selectedPipeline = pipelines.find((p) => String(p.sowId) === String(sowId));

  const pipelineOptions = useMemo(
    () => pipelines.map((p) => ({ value: p.sowId, label: p.label })),
    [pipelines]
  );

  return (
    <div className="spacer-log-dashboard__filterbar spacer-log-day-toolbar">
      <div className="spacer-log-dashboard__fb-group spacer-log-dashboard__fb-group--pipeline">
        <span className="spacer-log-dashboard__fb-label">Pipeline</span>
        {pipelines.length > 1 ? (
          <Select
            className={PIPELINE_SELECT_CLASS}
            dropdownClassName={PIPELINE_SELECT_DROPDOWN}
            getPopupContainer={getPopupContainerBody}
            suffixIcon={<DownOutlined />}
            value={sowId ?? undefined}
            options={pipelineOptions}
            onChange={(value) => onSowChange?.(value)}
            placeholder="Select pipeline"
          />
        ) : (
          <span className="spacer-log-day-toolbar__pipeline-value">
            {selectedPipeline?.label || pipelines[0]?.label || '—'}
          </span>
        )}
      </div>

      <div className="spacer-log-dashboard__fb-group">
        <span className="spacer-log-dashboard__fb-label">Log Date</span>
        <DatePicker
          className="dpr-date-picker spacer-log-day-toolbar__datepicker"
          dropdownClassName="dpr-date-picker-dropdown"
          value={pickerValue}
          onChange={(d) => {
            if (d) onLogDateChange?.(d.format('YYYY-MM-DD'));
          }}
          format="DD-MMM-YYYY"
          allowClear={false}
          disabledDate={dataRange ? disabledDate : undefined}
          placeholder="Select date"
        />
      </div>

      {showShiftToggle ? (
        <div className="spacer-log-day-toolbar__shift">
          <div className="spacer-log-shift-toggle">
            {[
              { key: 'both', label: 'Both' },
              { key: '0', label: 'Day' },
              { key: '1', label: 'Night' },
            ].map((s) => (
              <button
                key={s.key}
                type="button"
                className={`spacer-log-shift-btn${shiftFilter === s.key ? ' spacer-log-shift-btn--active' : ''}`}
                onClick={() => onShiftFilterChange?.(s.key)}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      {showAiInsights ? (
        <div className="spacer-log-dashboard__fb-group spacer-log-dashboard__fb-group--ai">
          <button
            type="button"
            className="spacer-log-ai-btn spacer-log-ai-btn--primary"
            disabled={Boolean(aiDisabledReason)}
            title={aiDisabledReason || 'AI insights for this day'}
            onClick={() => onOpenAiInsight?.()}
          >
            AI insights
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default SpacerLogDayToolbar;
